import React from 'react';
import 'twin.macro';
import { Field } from 'react-final-form';
import { CJAtelier } from 'types/cj';
import { AteliersForm } from './AteliersForm';
import useEleves from 'queries/eleves/useEleves';
import { useTranslation } from 'react-i18next';

interface Props {
  cycle?: string;
}

export function AteliersBody(props: Props) {
  const { cycle } = props;
  const { data: eleves } = useEleves();
  const { t } = useTranslation(['cahierJournal']);
  return (
    <Field<CJAtelier[]>
      name="ateliers"
      render={({ input: { value, onChange } }) => (
        <>
          <h4 tw="text-neutral-moderate mb-2 flex items-center gap-1">
            {t('cahierJournal:seance.modal.ateliers')}
          </h4>
          <AteliersForm
            eleves={eleves || []}
            ateliers={value}
            onChange={onChange}
            cycle={cycle}
          />
        </>
      )}
    />
  );
}
